import * as React from 'react'
import { ButtonGroup, Button, Modal } from 'react-bootstrap'
import { ReadOnlyEventList } from './ReadOnlyEventList'
import { DownTime } from '../../model/DownTime'

interface DispatchProps {
  cancel: () => void
  ok: () => void
  dateFormatter: (date: Date) => JSX.Element
}

interface StateProps {
  eventsToWarnAboutReverting: DownTime[]
}

type State = {}

type Props = DispatchProps & StateProps

export class RevertWarningModal extends React.Component<Props, State> {
  public render() {
    return (
      <Modal
        show={this.props.eventsToWarnAboutReverting !== null}
        onHide={() => this.props.cancel()}
        centered
        dialogClassName="modal-90w"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Reverting this event will automatically revert associated events
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="fixed">The following Downtime Events will be reverted</p>
          <ReadOnlyEventList
            data={this.props.eventsToWarnAboutReverting}
            dateFormatter={this.props.dateFormatter}
          />
          <p className="fixed">Do you want to continue with the revert?</p>
        </Modal.Body>
        <Modal.Footer>
          <ButtonGroup>
            <Button variant="primary" onClick={this.props.ok}>
              Revert
            </Button>
            <Button variant="warning" onClick={this.props.cancel}>
              Cancel
            </Button>
          </ButtonGroup>
        </Modal.Footer>
      </Modal>
    )
  }
}
